import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
const store = new Vuex.Store({
	state:{
		modelCode:"",
		modelName:"",
        modelYear: "",
		brandName:"",
		cityName:"",
		cityCode:"",
		tempFilePaths:"",
		VIN:"",
		startDate:"",
        marketTabList: [],
        chooseLabel: "",
        isCleanForm:true,
        carData:[],
        chooseType:[],
        seriesIds:"",
        reportData:{},
        color:"",
        mileage:"",
        brandCode: "",
        seriesCode: "",
        provinceCode: "",
        fixedTop: false,
        tabList: {
		    priceTab: 'price',
            marketTab: 1,
        },
        searchFormResult: null,
        searchRequestData: null,
        screenListContent: {matchType: 0, timeType: 0, sort: 0, cityCode: ''},
        clientHeight: '',
        newPrice: '',
        vinParseConfig:{},
        uniqueValue: "", // 结果页调用接口需要传的参数（时间戳）
	},
	mutations:{
        updateReportData(state, value) {
            state.reportData = value.reportData;
        },
		updateCity(state, value) {
            state.cityName = value.cityName;
            state.cityCode = value.cityCode;
            state.provinceCode = value.provinceCode;
        },
        updateSeriesIds(state, value){
            state.seriesIds = value.seriesIds;
        },
        updateCarData(state, value){
            state.carData = value.carData;
        },
        updateChooseType(state, value){
            state.chooseType = value.chooseType;
        },
        updateVinParseConfig(state, value){
            state.vinParseConfig = value.vinParseConfig;
        },
        updateBrand(state, value) {
            state.modelName = value.modelName;
            state.modelCode = value.modelCode;
            state.modelYear = value.modelYear;
            state.brandName = value.brandName;
            state.brandCode = value.brandCode;
            state.seriesCode = value.seriesCode;
        },
        updateTempFilePaths(state,value){
        	state.tempFilePaths = value.tempFilePaths;
        },
        updateVIN(state,value){
        	state.VIN = value.VIN;
        },
        updateStartDate(state,value){
        	state.startDate = value.startDate;
        },
        updateMarketTabList(state, value) {
            state.marketTabList = value.marketTabList;
        },
        updateChooseLabel(state, value) {
            state.chooseLabel = value.chooseLabel;
        },
        updateIsCleanForm(state,value){
            state.isCleanForm = value.isCleanForm;
        },
        updateColor(state,value){
            state.color = value.color;
        },
        updateMileage(state,value){
            state.mileage = value.mileage;
        },
        screenCarListContent(state, value) {
            state.screenListContent = value.screenListContent;
        },
        setFixedTop(state, value) {
            state.fixedTop = value.fixedTop;
        },
        updateTabList(state, value) {
            state.tabList = value.tabList;
        },
        updateSearchFormResult(state, value) {
            state.searchFormResult = value.searchFormResult;
        },
        updateSearchRequestData(state, value) {
            state.searchRequestData = value.searchRequestData;
        },
        updateClientHeight(state, value) {
            state.clientHeight = value.clientHeight;
        },
        updateNewPrice(state, value) {
            state.newPrice = value.newPrice;
        },
        updateUniqueValue(state, value) {
            state.uniqueValue = value.uniqueValue;
        },
	},
	getters:{

	}
});
export default store;



// WEBPACK FOOTER //
// ./src/components/vuex/store.js